
export class HtmlPropertyValue {
    public constructor(public propertyName: string, public propertyValue: string) { }
}
